// Foto singole (finestre della home, card prodotto): il contenitore prende il
// tono di fondo della foto, misurato sui bordi, cosi' il rettangolo della foto
// non si vede. Senza JS resta il tono calcolato dal tema per colore (--still-bg).
(() => {
  const SEL = '.lv-cat__img--still, .product-card__image-wrapper';
  const tone = async (img) => {
    const bm = await createImageBitmap(await (await fetch(img.currentSrc || img.src)).blob());
    const c = document.createElement('canvas');
    c.width = bm.width; c.height = bm.height;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(bm, 0, 0);
    const w = bm.width, h = bm.height, m = 3, px = [];
    for (let i = 0; i <= 8; i++) {
      const a = Math.round((w - 1 - 2 * m) * i / 8) + m, b = Math.round((h - 1 - 2 * m) * i / 8) + m;
      px.push([a, m], [a, h - 1 - m], [m, b], [w - 1 - m, b]);
    }
    const ch = [0, 1, 2].map((k) => {
      const v = px.map(([a, b]) => x.getImageData(a, b, 1, 1).data[k]).sort((p, q) => p - q);
      return v[v.length >> 1];
    });
    return `rgb(${ch.join(',')})`;
  };
  const run = async (img) => {
    const box = img.closest(SEL);
    if (!box || img.dataset.lvTone) return;
    img.dataset.lvTone = '1';
    try { box.style.setProperty('--still-bg', await tone(img)); } catch (e) { /* resta il tono del tema */ }
  };
  const scan = () => document.querySelectorAll('.lv-cat__img--still .lv-cat__a, .product-card__image--still img').forEach((img) => {
    if (img.complete && img.naturalWidth) run(img);
    else img.addEventListener('load', () => run(img), { once: true });
  });
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
